// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var UseResizeObserver = require("./UseResizeObserver.bs.js");

function ContentWithStickyHeader(Props) {
  var topOpt = Props.top;
  var header = Props.header;
  var content = Props.content;
  var top = topOpt !== undefined ? topOpt : 0;
  var match = React.useState(function () {
        return top;
      });
  var setContentTop = match[1];
  var headerRef = React.useRef(null);
  UseResizeObserver.useClientHeightObserver(headerRef, (function (headerHeight) {
          Curry._1(setContentTop, (function (param) {
                  return top + headerHeight | 0;
                }));
        }));
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  ref: headerRef,
                  style: {
                    background: "white",
                    position: "sticky",
                    top: "" + String(top) + "px",
                    zIndex: "1000"
                  }
                }, header), Curry._1(content, match[0]));
}

var make = ContentWithStickyHeader;

exports.make = make;
/* react Not a pure module */
